import { render, staticRenderFns } from "./certificates-form.vue?vue&type=template&id=04872211&scoped=true"
import script from "./certificates-form.vue?vue&type=script&lang=js"
export * from "./certificates-form.vue?vue&type=script&lang=js"
import style0 from "./certificates-form.vue?vue&type=style&index=0&id=04872211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04872211",
  null
  
)

export default component.exports